import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

const COLORS = ["#0ea5e9", "#4d7c0f", "#b91c1c"]; // Colors for Hyd, Bgl, Mgl

export default function RevenuePieChart({ misData }) {
  if (!misData?.info) return null;

  // Revenue values
  const hydOhm = misData?.info?.hyd_ohm?.revenue?.total || 0;
  const hydUber = misData?.info?.hyd_uber?.revenue?.total || 0;
  const hydSubs = misData?.info?.hyd_subs?.revenue?.total || 0;
  const hydB2B = misData?.info?.hyd_b2b?.revenue?.total || 0;

  const bglTotal = misData?.info?.bgl_ohm?.revenue?.total || 0;
  const mglTotal = misData?.info?.mgl_ohm?.revenue?.total || 0;

  // Pie data (3 cities total)
  const data = [
    { name: "Hyderabad", value: hydOhm + hydUber + hydSubs + hydB2B },
    { name: "Bangalore", value: bglTotal },
    { name: "Mangalore", value: mglTotal },
  ];

  // ✅ Custom Legend Renderer with Hyderabad bifurcation
  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <div className="flex flex-col items-center mt-4">
        <ul className="list-none p-0 m-0 text-sm">
          {payload.map((entry, index) => {
            if (entry.value === "Hyderabad") {
              return (
                <li key={`legend-hyd`} className="mb-2">
                  <div className="flex items-center font-semibold">
                    <span
                      className="inline-block w-3 h-3 mr-2 rounded-sm"
                      style={{ backgroundColor: entry.color }}
                    ></span>
                    Hyderabad: ₹{data[0].value.toLocaleString()}
                  </div>
                  <ul className="ml-6 mt-1 list-disc text-gray-700">
                    <li>OHM: ₹{hydOhm.toLocaleString()}</li>
                    <li>Uber: ₹{hydUber.toLocaleString()}</li>
                    <li>Subscription: ₹{hydSubs.toLocaleString()}</li>
                    <li>B2B: ₹{hydB2B.toLocaleString()}</li>
                  </ul>
                </li>
              );
            } else {
              const cityValue =
                data.find((d) => d.name === entry.value)?.value || 0;
              return (
                <li
                  key={`legend-${entry.value}`}
                  className="flex items-center mb-2 font-medium"
                >
                  <span
                    className="inline-block w-3 h-3 mr-2 rounded-sm"
                    style={{ backgroundColor: entry.color }}
                  ></span>
                  {entry.value}: ₹{cityValue.toLocaleString()}
                </li>
              );
            }
          })}
        </ul>
      </div>
    );
  };

  return (
    <div className="flex flex-col w-full h-full items-center">
      <ResponsiveContainer width="100%" height="80%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius="70%"
          >
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => `₹${value.toLocaleString()}`} />
          <Legend
            verticalAlign="bottom" // ✅ Legend below chart
            align="center"
            layout="horizontal"
            content={renderLegend}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
